/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'

const SessionContext = React.createContext()

// const ROOT_URL = '/.netlify/functions'
const DEFAUL_SESSION = { 
  hasAccount: false,
  loggedIn: false,
  avatarUrl: null
}

const SessionProvider = ({
  children
}) => {
  // fetch the cookies and initialize the session
  const [cookies] = useCookies(['box_active_user_subdomain', 'logged_in'])
  const [session, setSession] = useState(DEFAUL_SESSION)

  // sets the session to a state where we know the user has an account
  // and uses a cookie to determine the user's logged in state
  const setHasAccount = () => setSession(s => ({...s, ...{ 
    hasAccount: true,
    loggedIn: cookies.logged_in === 'true'
  }}))

  // // fetches the user details if needed
  // const fetchUserDetails = async () => {
  //   // dont fetch if we already have the details
  //   if (cookies.logged_in === 'true') { return }
  //   // make the call to a netlify function to unpack the HTTP only cookie
  //   const response = await fetch(`${ROOT_URL}/fetch-session`)
  //   // if the status is not 200, fail silently
  //   if (response.status !== 200) { return }
  //   // parse the response, and set a new cookie so we dont have to do
  //   // this on every page load
  //   const data = await response.json()
  //   // expire this cookie in 1 day
  //   const expireDate = new Date(new Date().getTime() + (60 * 60 * 24 * 1000 * 1))
  //   setCookie('logged_in', data.loggedIn, { secure: process.env.NETLIFY, expires: expireDate })
  //   // update the session
  //   setSession(data)
  // }

  // check if the box_active_user_subdomain cookie is set and if so start 
  // updating the session and fectching user details
  useEffect(() => {
    if (!cookies.box_active_user_subdomain) { return }
    setHasAccount()
    // fetchUserDetails()
  }, [])
  
  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  )
}

/* eslint-disable react/display-name */
const withSession = (WrappedComponent) => (
  (props) => (
    <SessionContext.Consumer>
      {(session) => {
        return (
          <WrappedComponent {...props} session={session} />
        )
      }}
    </SessionContext.Consumer>
  )
)

export default SessionContext
export { SessionProvider, withSession }